import React from "react"
import { Link, useStaticQuery, graphql } from "gatsby"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

//styles
import { Container } from "./footer.styles"

const query = graphql`
  {
    facebookLogo: file(relativePath: { regex: "/facebook_logo.png$/" }) {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH)
      }
    }
    instaLogo: file(relativePath: { regex: "/insta_logo.png$/" }) {
      childImageSharp {
        gatsbyImageData(layout: FULL_WIDTH)
      }
    }
  }
`

const Footer = () => {
  const data = useStaticQuery(query)
  const facebookLogo = getImage(data.facebookLogo)
  const instaLogo = getImage(data.instaLogo)

  return (
    <Container>
      <div>
        <a
          href="https://www.facebook.com/Sp%C3%A4tsommer-GmbH-108499671677545/?ref=page_internal"
          rel="noopener noreferrer"
          target="_blank"
        >
          <GatsbyImage
            image={facebookLogo}
            alt="facebook"
            imgStyle={{ objectFit: "contain" }}
          />
        </a>
        <a
          href="https://www.instagram.com/spaetsommergmbh/"
          rel="noopener noreferrer"
          target="_blank"
        >
          <GatsbyImage
            image={instaLogo}
            alt="instagram"
            imgStyle={{ objectFit: "contain" }}
          />
        </a>
      </div>
      <Link to="/impressum">Impressum</Link>
      <Link to="/datenschutz">Datenschutz</Link>
      <span>&copy; 2020 SPÄTSOMMER</span>
    </Container>
  )
}

export default Footer
